import React, { forwardRef, useState } from "react";

import EventNotes from "../EventNotes";
import { createGuidId } from "../../../utils/teams-dragger";
import Header from "../Header";
import ConfirmButton from "../ConfirmButton";
import Submit from "./../HandleSubmit";

const handleSubmit = (params) => {
    const {
        eventDetailsToAdd: event,
        matchId,
        matchData,
        setMatchData,
        formatApiData,
        sides,
        homePlayers,
        awayPlayers,
        setEventsToShow,
    } = params;

    const comment = event?.eventNotes ? event?.eventNotes.trim() : null;
    const timestamp = event.timestamp;
    const minute = Math.ceil(timestamp / 60);
    const orderIndex = matchData.matchPosts.length;
    let quarter = "";
    switch (event.quarterSelected) {
        case "Q1":
            quarter = 1;
            break;
        case "Q2":
            quarter = 2;
            break;
        case "Q3":
            quarter = 3;
            break;
        case "Q4":
            quarter = 4;
            break;
        case "SO":
            quarter = 0;
            break;
    }

    const commentEvent = {
        type: "Comment",
        postType: 17,
        match: matchId,
        minute,
        orderIndex,
        additionalData: comment,
        isLive: true,
        quarter,
    };

    const update = {
        ...(matchData.status < 3 ? { isPreMatchComment: true } : {}),
        matchPosts: [...matchData.matchPosts, commentEvent],
    };

    Submit(matchId, matchData, update, setMatchData)
        .then((data) =>
            formatApiData(
                data,
                sides,
                setEventsToShow,
                ...homePlayers,
                ...awayPlayers
            )
        )
        .catch((e) => console.error(e.message));
};

const AddEventNotes = forwardRef(
    (
        {
            setIsModalOpen,
            setEventsToShow,
            eventDetailsToAdd,
            setEventDetailsToAdd,
            setSides,
            goals,
            setGoals,
            isEditing,
            setIsEditing,
            matchId,
            matchData,
            setMatchData,
            formatApiData,
            homePlayers,
            awayPlayers,
            sides,
        },
        ref
    ) => {
        return (
            <div
                ref={ref}
                style={{
                    backgroundColor: "#E5E5E5",
                }}
            >
                <Header
                    eventDetails={eventDetailsToAdd}
                    setEventDetails={setEventDetailsToAdd}
                    setModalOpen={setIsModalOpen}
                    setSides={setSides}
                    goals={goals}
                    setGoals={setGoals}
                    isEditing={isEditing}
                />

                <>
                    <EventNotes
                        textAreaValue={eventDetailsToAdd?.eventNotes}
                        showConfirmCancelButtons={
                            !!eventDetailsToAdd?.eventNotes?.length
                        }
                        confirmButtonAction={() => {}}
                        cancelButtonAction={() => {
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                eventNotes: "",
                            }));
                        }}
                        onChange={(e) => {
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                eventNotes: e.target.value,
                            }));
                        }}
                    />

                    <ConfirmButton
                        action={() => {
                            if (eventDetailsToAdd.eventNotes) {
                                handleSubmit({
                                    eventDetailsToAdd,
                                    matchId,
                                    matchData,
                                    setMatchData,
                                    formatApiData,
                                    sides,
                                    homePlayers,
                                    awayPlayers,
                                    setEventsToShow,
                                });
                                setEventsToShow((data) => {
                                    return [
                                        ...data,
                                        {
                                            id: createGuidId(),
                                            ...eventDetailsToAdd,
                                        },
                                    ];
                                });
                                setIsEditing(false);
                                setIsModalOpen(false);
                            }
                        }}
                    />
                </>
            </div>
        );
    }
);

export default AddEventNotes;
